<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
       <!-- <h2 class="mb-4">{{ __('lang.categories_head')}}</h2>
         <div class="mb-4">
          <a class="btn btn-sm btn-link pl-0 global-select-all" role="button" id="all_check"  @click.prevent="setcheckedall(true)" >
            <svg class="icon icon-xs">
              <use xlink:href="/assets/img/icon-sprite.svg#global.check" xmlns:xlink="http://www.w3.org/1999/xlink">
              </use>
            </svg>{{__('lang.btn.select_all')}}</a>
          <a class="btn btn-sm btn-link global-deselect-all" role="button" id="all_uncheck" @click.prevent="setcheckedall(false)">
            <svg class="icon icon-xs">
              <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
              </use>
            </svg>{{__('lang.btn.unselect_all')}}</a>
          <a class="btn btn-sm btn-link global-collapse-show-all" role="button"  @click.prevent="setcollapseall(true)">
              <svg class="icon icon-xs">
                <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink">
                </use>
              </svg>Alle ausklappen</a>
          <a class="btn btn-sm btn-link global-collapse-hide-all" role="button" @click.prevent="setcollapseall(false)">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse-up" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>Alle einklappen</a>
        </div> -->
        <form class="needs-validation" id="room-edit" method="post" novalidate="novalidate">



          <div v-show ="parentID != 'tab_ds'" class="form-row mb-3" v-for="(cat, catIndex) in categories.filter(catitem => catitem.f_filter == 1)" :key="cat.id">
              <div class="col-12">
              <!--   <h6 class="mb-0" role="button" data-toggle="collapse" :data-target="'#group_' + catIndex" :aria-expanded="catIndex <= 1 ? true : false" :aria-controls="'group_' + catIndex"> -->
                <h6 class="mb-0" role="button" data-toggle="collapse" :data-target="'#group_' + catIndex" :aria-expanded="true" :aria-controls="'group_' + catIndex">
                  <svg class="icon icon-xs mr-2">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                  </svg>{{ cat.description_short }}
                </h6>
                <div class="mb-3"><a class="btn btn-sm btn-link pl-0 select-all" role="button" :id="cat.id + '_check'"  @click.prevent="setchecked(cat.subcategories.filter(subcatitem => subcatitem.f_filter == 1), true)">{{ __('lang.btn.select_all') }}</a><a class="btn btn-sm btn-link deselect-all" role="button" @click.prevent="setchecked(cat.subcategories.filter(subcatitem => subcatitem.f_filter == 1), false)">{{ __('lang.btn.unselect_all') }}</a></div>
              </div>
             <!--  <div :class="'form-row w-100 collapse' + (catIndex <= 1 ? ' show' : '')" :id="'group_' + catIndex"> -->
               <div :class="'form-row w-100 collapse show'" :id="'group_' + catIndex">
                <div class="image-checkbox  col-sm-12 col-md-2  mb-2" v-for="(subcat, subcatIndex) in cat.subcategories.filter(subcatitem => subcatitem.f_filter == 1)" :key="subcat.id">
                  <input type="checkbox" :name="'cat[' + subcat.categoryChildId + ']'" :id="'cat_' + subcat.categoryChildId" :value="subcat.categoryChildId" v-model="selectedcategories[subcat.categoryChildId]" @change="setclass_check(cat.id, selectedcategories[subcat.categoryChildId])"/>
                  <!-- <label :for="'cat_' + subcat.categoryChildId" data-toggle="tooltip" data-placement="top" v-b-tooltip.hover :title="subcat.description_short" data-selector="true"><img class="img-fluid" :src="'/mediadata/categories/' + subcat.image"/></label> -->
                  <label :for="'cat_' + subcat.categoryChildId" data-toggle="tooltip" data-placement="top" v-b-tooltip.hover :title="subcat.group_attributes" data-selector="true"><img class="img-fluid" :src="'/mediadata/categories/' + subcat.image"/></label>
                  <p class="small text-center">{{ subcat.description_short }}</p>
                </div>
               
              </div>
            </div>
          
          <div v-show ="parentID == 'tab_ds'" class="form-row mb-3" v-for="(cat, catIndex) in categories_ds" :key="cat.id">
              <div class="col-12">
                <!-- <h6 class="mb-0" role="button" data-toggle="collapse" :data-target="'#group_' + catIndex" :aria-expanded="catIndex <= 1 ? true : false" :aria-controls="'group_' + catIndex"> -->
                  <h6 class="mb-0" role="button" data-toggle="collapse" :data-target="'#group_' + catIndex" :aria-expanded="true" :aria-controls="'group_' + catIndex">
                <svg class="icon icon-xs mr-2">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>{{ cat.description_short }}
                </h6>
                <div class="mb-3"><a class="btn btn-sm btn-link pl-0 select-all" role="button" :id="cat.id + '_check'"  @click.prevent="setchecked(cat.subcategories, true)">{{ __('lang.btn.select_all') }}</a><a class="btn btn-sm btn-link deselect-all" role="button" @click.prevent="setchecked(cat.subcategories, false)">{{ __('lang.btn.unselect_all') }}</a></div>
              </div>
              <!-- <div :class="'form-row w-100 collapse' + (catIndex <= 1 ? ' show' : '')" :id="'group_' + catIndex"> -->
              <div :class="'form-row w-100 collapse show'" :id="'group_' + catIndex">
                <div class="image-checkbox  col-sm-12 col-md-2 mb-2" v-for="(subcat, subcatIndex) in cat.subcategories" :key="subcat.id">
                  <input type="checkbox" :name="'cat[' + subcat.categoryChildId + ']'" :id="'cat_' + subcat.categoryChildId" :value="subcat.categoryChildId" v-model="selectedcategories[subcat.categoryChildId]" @change="setclass_check(cat.id, selectedcategories[subcat.categoryChildId])"/>
                  <!-- <label :for="'cat_' + subcat.categoryChildId" data-toggle="tooltip" data-placement="top" v-b-tooltip.hover :title="subcat.description_short + ' ' + subcat.group_attributes" data-selector="true"><img class="img-fluid" :src="'/mediadata/categories/' + subcat.image"/></label> -->
                  <label :for="'cat_' + subcat.categoryChildId" data-toggle="tooltip" data-placement="top" v-b-tooltip.hover :title="subcat.group_attributes" data-selector="true"><img class="img-fluid" :src="'/mediadata/categories/' + subcat.image"/></label>
                   <p class="small text-center">{{ subcat.description_short }}</p>
                </div>
               
              </div>
          </div>
          
          
        </form>
      </div>
    </div>
  </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    import operatingpointApi from './services/api/operatingpointAPI'
export default {
        props: ['parentID'], //from directsearchtab ='tab_ds', from operatingpoint ='tab_op'
        computed: {
          selectedcategories: {   
                get () {
                    return this.$store.state.operatingpoint.selectedCategories
                },   
                set(value){ 
                 this.$store.commit('operatingpoint/updateSelectedCategories', value)
                }
          },
        },
        data() {
          return {
            categories: [],
            categories_ds: [],
            //selectedcategories:{}
          }
		    },
        methods: {  
          async getCategories() {
            var body=[]

            
            body.push({
                        language_id: this.$lang().locale, //navigator.language,
                      })
            var response = await operatingpointApi.getCategories(body);
            this.categories = response.categories;
            this.$store.commit('operatingpoint/setCategories', response.categories)
            console.log('Categories getCategories:this.categories');
          
            console.log(response.categories);
            
                            
          },  	
          async getCategoriesDirectsearch() {
            var body = []


            body.push({
              language_id: this.$lang().locale, //navigator.language,
              filter: 0
            })
            var response = await operatingpointApi.getCategories(body);
            this.categories_ds = response.categories;
            
            this.$store.commit('operatingpoint/setCategories', response.categories)
            console.log('Categories getCategoriesDirectsearch');

            console.log(response.categories); 

          },
    
          storeCategories: function(){
            var arr=[]
            var cats_desc=[]

            console.log('storeCategories this.selectedcategories:')
            console.log(this.selectedcategories)



            for (let value of Object.keys(this.selectedcategories) ){
                if(this.selectedcategories[value] == true){
                  arr = this.categories.map(function (categories) { 
                                          var c= categories.subcategories.filter(x=> x.categoryChildId==value)
                                          return c
                                        })
                                        .filter(v => Object.keys(v).length !== 0)
                  for (let v of Object.keys(arr) ){
                    var arr1=arr[v].map(function (desc) { 
                                    return desc.description_short
                                  })
                    var cd={}           
                    Object.assign(cd, {
                      id: value,
                      desc: arr1[0]
                    })
                    cats_desc.push(cd);
                  }
                }
            }
          /*   console.log('selectedcategories:')
            console.log(this.selectedcategories)
            console.log('storeCategories cats_desc:')
            console.log(cats_desc) */

            var tmpcategories = Object.assign({}, this.selectedcategories)

            //this.$store.commit('operatingpoint/updateSelectedCategories', this.selectedcategories)
            this.$store.commit('operatingpoint/setDescSelectedCategories', cats_desc)
            this.$store.commit('operatingpoint/updateSelectedTmpCategories', tmpcategories)
            

            if (this.parentID == 'tab_ds') {
              this.$root.$refs.main.listenerchild({ nav: "3", searchflag: "cat" });
             /*  this.$store.commit('operatingpoint/setDescSelectedCategories', [])
              this.$store.commit('operatingpoint/updateSelectedTmpCategories', []) */
            }

            
            document.getElementById('closecategoriesModal').click();

            
          },
          restoreCategories: function () { 
            
            var selectedTmpCategories = this.$store.state.operatingpoint.selectedTmpCategories
           /*  console.log('restoreCategories')
            console.log('OP selectedTmpCategories')
            console.log(selectedTmpCategories)
             */
            this.selectedcategories = Object.assign({},selectedTmpCategories)
/* 
            console.log('OP this.selectedCategories')
            console.log(this.selectedcategories) */

            
            //this.$store.commit('operatingpoint/updateSelectedCategories', this.$store.state.operatingpoint.selectedTmpCategories)
          },
          setchecked: function(subcats,check){
            var selected={}
            Object.assign(selected,this.selectedcategories)
           
            let parentcategory = [...new Set(subcats.map(subcatitem => subcatitem.categoryParentId))];

            /*
            var all_a_check = document.querySelectorAll("[id^='"+parentcategory[0]+"_check"+"']");
            console.log('parentcategory all_a_check:')
            console.log(all_a_check)
            for (var a_check of all_a_check) {
              if(check) a_check.classList.add("font-weight-bold");
              else {
                  a_check.classList.remove("font-weight-bold");
                  document.getElementById('all_check').classList.remove("font-weight-bold");
              } 
            }  */
            


            var cats= subcats.map(subcatitem => subcatitem.categoryChildId)
           

            for (let v of Object.values(cats) ){
              selected[v]=check
            }
            this.selectedcategories=Object.assign({},this.selectedcategories,selected)

            this.setclass_check(parentcategory,check)
           /*  console.log('setchecked parent:')
            console.log(parentcategory) */
           
          },
          setcheckedall: function(check,from){
            var selected = {}
            var cats_tmp
            
            Object.assign(selected, this.selectedcategories)
            
           
            
            if (from == 'ds') {
              cats_tmp = this.categories_ds
            }
            else cats_tmp = this.categories

             console.log('checkall:from', from)
            console.log('checkall:cats_tmp', cats_tmp)


            var cats = cats_tmp.map(function (categories) { 

              var c_no_filter = categories.subcategories.filter(subcatitem => subcatitem.f_filter == 0).map(subcatitem => subcatitem.categoryChildId)
              //cats not in filter:
              for (let v of Object.values(c_no_filter)) {
                selected[v] =  from=='ds' ?  check : false
              }
              //cats in filter:
              var c = categories.subcategories.filter(subcatitem => subcatitem.f_filter == 1).map(subcatitem => subcatitem.categoryChildId)
                                       for (let v of Object.values(c) ){
                                         selected[v] = check
                                        }
                                      })
           
            this.selectedcategories = Object.assign({}, this.selectedcategories, selected)

            console.log('checkall:this.selectedcategories', this.selectedcategories)
            /*console.log(this.selectedcategories)*/
            this.setclass_check('all',check)
          },
          setclass_check: function (clickedparentcategory, check) {
            var cat = this.$store.state.operatingpoint.selectedCategories
            var allCategories = this.$store.state.operatingpoint.categories
            var count_allcat = 0;

            var all_a_check = document.querySelectorAll("[id$='_check']");
            var selected = this.selectedcategories
           
            var uniquesubcats = [...new Set()]
            var selectedcats = [...new Set()]
            
             
            allCategories.forEach(function (catlevel1) {
              if (catlevel1.subcategories.length > 0) {

                catlevel1.subcategories.forEach(function (catlevel2) {

                  if (selected[catlevel2.categoryChildId]==true) {
                  //if (selected.includes(catlevel2.categoryChildId)) { 
                    selectedcats.push({
                      catparentid: catlevel2.categoryParentId,
                      cutchildid: catlevel2.categoryChildId
                    })
                    
                  } 
                    
                  if (catlevel2.f_filter == 1 && !uniquesubcats.includes(catlevel2.categoryChildId)) {
                    count_allcat++
                    uniquesubcats.push(catlevel2.categoryChildId)
                  }
                })
              
              }
             
            });

            var cats = this.categories.map(function (categories) {
              //cats in filter:
              var countsubcats = categories.subcategories.filter(subcatitem => subcatitem.f_filter == 1).length
              return { catparentid: categories.id,
                       countsubcats: countsubcats
                    };
            })
          
            if(Object.keys(cat).filter( key => cat[key]==true).length ==0){
              for ( var a_check of all_a_check) {
                a_check.classList.remove("font-weight-bold");
              }
            }
            else if(Object.keys(cat).filter( key => cat[key]==true).length >1) {
                  
              var cat_count = parseInt(Object.keys(cat).filter(key => cat[key] == true).length) //-1 ???
                 
              for (var a_check of all_a_check) {
               
                    if(count_allcat==cat_count) a_check.classList.add("font-weight-bold");
                    else {
                      if (a_check.id == clickedparentcategory + '_check') {
                        //selected subcategorien in maincategorie must =  with total subcategorien in maincategorie 
                        if (check && selectedcats.filter(e => e.catparentid == clickedparentcategory).length == cats.filter(e => e.catparentid == clickedparentcategory).map(function (c) { return c.countsubcats })) {
                          a_check.classList.add("font-weight-bold")
                        }
                        else{
                          a_check.classList.remove("font-weight-bold")
                          document.getElementById('all_check').classList.remove("font-weight-bold")
                        }
                      }
                    }
                  }
            }
          },

          setcollapseall(show) { 
            var modalcontainer 
            if (this.parentID == "tab_ds")  modalcontainer = document.querySelector("#categoryModal_directsearch");
            else modalcontainer = document.querySelector("#categoryModal");
            var all_h6 = modalcontainer.querySelectorAll('[data-toggle="collapse"]')
            var all_cats = modalcontainer.querySelectorAll('[id^="group_"]');

            
            [...all_cats].forEach((item) => {
              /* console.log('setcollapseall item:')
              console.log(item) */
              if (show) item.classList.add('show');
              else item.classList.remove('show');
            });

            [...all_h6].forEach((item) => {
              /* console.log('h6 item:')
              console.log(item) */
              if (show) {
                item.setAttribute('aria-expanded', 'true')
                item.classList.remove('collapsed');
              }
              else {
                item.setAttribute('aria-expanded', 'false')
                item.classList.add('collapsed');

              }
              
            });

            //const matches = modalcontainer.querySelectorAll("div.highlighted > p");

           /*
            if (show == true) { 
             $(this).parents('#categoryModal').find('#type-filter [data-toggle="collapse"]').attr('aria-expanded', 'true').removeClass('collapsed');
              $(this).parents('#categoryModal').find('#type-filter .collapse').addClass('show'); 
              //all_cats.addClass('show');
            }
            else {
              $(this).parents('#categoryModal').find('#type-filter [data-toggle="collapse"]').attr('aria-expanded', 'false').addClass('collapsed');
              $(this).parents('#categoryModal').find('#type-filter .collapse').removeClass('show'); 
              //all_cats.find('.collapse').removeClass('show');
          }
            */

          }
        },
        mounted () {
        },
        created() {
          //this.getCategories()
         
        },
       /*
        watch: {
          selectedcategories:{
            handler: function(){
              this.storeCategories();
            },
            deep:true //You need to set deep to true when watching an array or object so that Vue knows that it should watch the nested data for changes.
          }
        }
        */
        
       
        


       
    }
  

</script>